import React from 'react'
import { Header1, Text } from '../../styles/Components'
import Button from '../Button'
import { gsColors } from '../../styles/Variables'

const HeaderContent = ({ handleClick }) => {
  return (
    <>
      <Header1
        color={gsColors.salmon}
        className="web-header-text"
        margin="0 0 24px"
      >
        EVENTS,
        <br />
        GROUP GLAM +<br />
        PHOTOSHOOTS
      </Header1>
      <Header1 color={gsColors.salmon} className="mobile-header-text">
        Events, Group Glam
        <br />+ Photoshoots
      </Header1>
      <Text
        color={gsColors.white}
        lineHeight="138%"
        fontSize={22}
        margin="0 0 48px"
      >
        From private events to corporate functions to on-set services, we offer
        completely customizable, on-demand glam for groups and events of all
        sizes.
      </Text>
      <Button
        onClick={handleClick}
        large
        color={gsColors.salmon}
        style={{ color: gsColors.cobalt }}
      >
        Get Started
      </Button>
    </>
  )
}

export default HeaderContent
